import { useId } from 'react'
import './FAQItem.css'

type Props = { question: string; answer: string }

export default function FAQItem({ question, answer }: Props) {
  const id = useId()
  return (
    <details className="faq-item" name="faq">
      <summary className="faq-item__q" aria-controls={id}>
        <span>{question}</span>
        <span className="faq-item__icon" aria-hidden />
      </summary>
      <div id={id} className="faq-item__a">
        <p>{answer}</p>
      </div>
    </details>
  )
}
